import type { InsuranceType } from '@/@types/insurance';

export enum UpsellOfferOrigin {
  MEIN_PLUS = 'MEIN_PLUS',
  RENT_PROFILE = 'RENT_PROFILE',
  TENANT_VIEW = 'TENANT_VIEW',
}

export enum OfferType {
  MIETER_PLUS = 'MIETER_PLUS',
  WOHNEN_PLUS = 'WOHNEN_PLUS',
  WOHNEN_PLUS_LIGHT = 'WOHNEN_PLUS_LIGHT',
}

export interface UpsellOfferResponse {
  isEligible: boolean;
  showOffer: boolean;
  showCount: number;
  // Absent/null means this response supplies no provider
  insuranceType?: InsuranceType | null;
}
